export const getLinkHost = (link: any) => {
  const url = new URL(link.replace(/\/$/, ''));
  return url.host.replace('www.', '');
};

export const getLinkPath = (link: any) => {
  const url = new URL(link.replace(/\/$/, ''));
  return url.pathname.replace(/^\//, '');
};

export const getLinkSearch = (link: any) => {
  const url = new URL(link.replace(/\/$/, ''));
  return url.search;
};

export const getLinkHostAndPath = (link: any) => {
  const url = new URL(link.replace(/\/$/, ''));
  return url.host.replace('www.', '') + url.pathname;
};
